<template>
  <div class="site-background">
    <br aria-hidden="true" />
    <br aria-hidden="true" />
    <ProgressBars @mute-clicked="onMuteClicked()"></ProgressBars>
    <br aria-hidden="true" />
    <!-- <div class="bg-select-video-area" v-show="!newVersion()">
      <div class="row">
        <div class="col-sm-4">
          <div class="bg-color-vid-green">
            <p v-html="LG(getParagraph())"></p>
            <ul v-for="(bullet, index) in getBullets()" :key="bullet.text">
              <li v-html="LG(getBulletText(index))" v-show="!hasBulletPopover(index)"></li>
              <li v-show="hasBulletPopover(index)">
                <PopupLinker :paragraph="LG(getBulletText(index))" :content="LG(getBulletPopover(index))"></PopupLinker>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="selection-vid-area">
            <br />
            <br />
            <div v-show="hasVideo()">
              <img class="centered-element" :src="spinnerUrl" v-show="videoLoading" alt="" />
              <VideoPlayer ref="videoPlayerRef" :youtube="isVideoYoutube()" width="100%" height="340" class="centered-element video-element" :url="getVideoUrl()" :poster="getVideoPoster()" :transcription="getVideoTranscription()" @video-started="onVideoStarted()" @video-ended="onVideoEnded()" @video-ready="onVideoReady()" v-show="!videoLoading"></VideoPlayer>
            </div>
            <div v-show="!hasVideo()" class="replace-vid-area">
              <br />
              <br />
              <br />
              <p v-html="LG(getReplaceVideo())"></p>
            </div>
            <br />
            <div class="centered-element">
              <b-button class="funky-shape" v-show="!isStartButtonDisabled()" v-on:click="onStartButtonClicked()">{{ LG("G_startButtonLabel") }}</b-button>
            </div>
            <br />
          </div>
        </div>
      </div>
    </div> -->

    <div v-show="newVersion()">
      <br aria-hidden="true" />
      <div class="map-container-new">
        <div class="video-left-side">
          <div class="video-text-bubble-new">
            <p v-html="LG(getParagraph())"></p>
            <ul>
              <li class="mb-3" v-for="(bullet, index) in getBullets()" :key="bullet.text">
                <span v-html="LG(getBulletText(index))" v-if="!hasBulletPopover(index)"></span>
                <span v-if="hasBulletPopover(index)">
                  <PopupLinker :paragraph="LG(getBulletText(index))" :content="LG(getBulletPopover(index))" :content2="LG(getBulletPopover2(index))"></PopupLinker>
                </span>
              </li>
            </ul>
            <p v-show="isStartButtonDisabled()" v-html="LG('SV_watchVideo')"></p>
          </div>

          <div class="bloc-note-link-wrapper h2">
            Écris tes observations dans le bloc-notes.
            <BlocNoteAndBtn :situationIndex="situationIndex" :noteId="0" class="recaps-bloc-note-btn" />
          </div>
        </div>

        <div class="selection-vid-container">
          <div class="selection-vid-area-new">
            <br aria-hidden="true" />
            <br aria-hidden="true" />
            <div v-if="hasVideo()">
              <img class="centered-element" :src="spinnerUrl" v-show="videoLoading" alt="En chargement" />
              <VideoPlayer :mediaId="getMediaId()" id="id-video-player-new" ref="videoPlayerRef" :youtube="isVideoYoutube()" width="95%" height="360" class="centered-element video-element" :url="getVideoUrl()" :track="getTrackUrl()" :poster="getVideoPoster()" :transcription="getVideoTranscription()" @video-started="onVideoStarted()" @video-ended="onVideoEnded()" @video-ready="onVideoReady()" v-show="!videoLoading"></VideoPlayer>
            </div>
            <div v-if="!hasVideo()" class="replace-vid-area">
              <br aria-hidden="true" />
              <br aria-hidden="true" />
              <br aria-hidden="true" />
              <p v-html="LG(getReplaceVideo())"></p>
            </div>
            <div class="centered-element">
              <b-button class="funky-shape" v-show="!isStartButtonDisabled()" v-on:click="onStartButtonClicked()">{{ LG("G_startButtonLabel") }}</b-button>
            </div>
            <br aria-hidden="true" />
          </div>
        </div>
      </div>
    </div>
    <br aria-hidden="true" />
    <br aria-hidden="true" />

    <PopupOverlay id="modal-intro" ref="popupRef" :popupImage="getPopupImage()" imageWidth="300" :okButtonLabel="LG('G_continueLabel')" @ok-clicked="onPopupStartButtonClicked()" @close-clicked="onPopupCloseButtonClicked()">
      <!-- <br aria-hidden="true" />
        <br aria-hidden="true" /> -->
      <h1 v-html="LG(getPopupTitle())"></h1>

      <div v-for="(popupParagraph, index) in getPopupParagraphs()" :key="popupParagraph.text">
        <div v-if="!hasPopupPopover(index)">
          <p v-html="LG(popupParagraph.text)"></p>
        </div>
        <div v-if="hasPopupPopover(index)">
          <PopupLinker :paragraph="LG(popupParagraph.text)" :content="LG(popupParagraph.popover)" :content2="getPopupParagragraphPopover2(popupParagraph)"></PopupLinker>
          <br aria-hidden="true" />
        </div>
      </div>
      <br aria-hidden="true" />
    </PopupOverlay>

    <AudioPlayer id="id-sitpop-audio" ref="popupAudioRef" v-if="hasPopupAudio()" :url="getPopupAudio()" autoplay="no"></AudioPlayer>
    <AudioPlayer id="id-sit-audio" ref="introAudioRef" v-if="hasIntroAudio()" :url="getIntroAudio()" @audio-ended="onIntroAudioEnded()"></AudioPlayer>
    <AudioPlayer id="id-continue-audio" ref="continueAudioRef" :url="continueAudio" autoplay="no"></AudioPlayer>
    <AudioPlayer id="id-watch-video" ref="watchVideoAudioRef" :url="watchVideo" autoplay="no"></AudioPlayer>
  </div>
</template>

<script>
import ProgressBars from "../components/ProgressBars.vue";
import PopupOverlay from "../components/PopupOverlayNew.vue";
import PopupLinker from "../components/PopupLinker.vue";
import VideoPlayer from "../components/VideoPlayer.vue";
import AudioPlayer from "../components/AudioPlayer.vue";

import BlocNoteAndBtn from "../components/BlocNoteAndBtn.vue";

export default {
  components: {
    ProgressBars,
    PopupOverlay,
    PopupLinker,
    VideoPlayer,
    AudioPlayer,
    BlocNoteAndBtn,
  },
  data() {
    return {
      areaName: this.$route.params.areaName,
      situationName: this.$route.params.situationName,

      // Arrays
      situations: [
        {
          id: "id-situation-1",
          paragraph: "SV_S1_Paragraph",
          bullets: [
            {
              text: "SV_S1_Bullet1",
            },
            {
              text: "SV_S1_Bullet2",
            },
            {
              text: "SV_S1_Bullet3",
            },
          ],
          popupImage: require("@/assets/scenes/scene1/MES1Area_selection.png"),
          videoUrl: "YYGfMUDiTjo",
          transcription: "/videos/scene1/intro.txt",
          audioUrl: "/audio/scene1/L'accueil des familles_004.mp3",
          altPopup: "SV_S1_AltPopup",
          replaceVideo: null,
          popupTitle: "SV_S1_popupTitle",
          popupParagraphs: [
            {
              text: "SV_S1_popupParagraph1",
              popover: "SV_S1_popupPopover1",
              popover2: "SV_S1_popupPopover2",
            },
          ],
          audioPopup: "/audio/scene1/L'accueil des familles_006.mp3",
        },
        {
          id: "id-situation-2",
          paragraph: "SV_S2_Paragraph",
          bullets: [
            {
              text: "SV_S2_Bullet1",
            },
            {
              text: "SV_S2_Bullet2",
            },
          ],
          popupImage: require("@/assets/scenes/scene2/MES2Area_selection.png"),
          //videoUrl: "/videos/scene2/intro.mp4",
          videoUrl: "https://content.jwplatform.com/videos/QxnQtFjx-O8RTBfsm.mp4",
          poster: "https://content.jwplatform.com/thumbs/QxnQtFjx-1280.jpg",
          mediaId: "QxnQtFjx",
          transcription: "/videos/scene2/intro.txt",
          audioUrl: "/audio/scene2/L'écoute visible_001.mp3",
          altPopup: "SV_S2_AltPopup",
          popupTitle: "SV_S2_popupTitle",
          popupParagraphs: [
            {
              text: "SV_S2_popupParagraph1",
            },
            {
              text: "SV_S2_popupParagraph2",
            },
            {
              text: "SV_S2_popupParagraph3",
              popover: "SV_S2_popupParagraph3_popover",
            },
            {
              text: "SV_S2_popupParagraph4",
            },
            {
              text: "SV_S2_popupParagraph5",
            },
            {
              text: "SV_S2_popupParagraph6",
            },
            {
              text: "SV_S2_popupParagraph7",
            },
          ],
          audioPopup: "/audio/scene2/L'écoute visible_002.mp3",
        },
        {
          id: "id-situation-3",
          paragraph: "SV_S3_Paragraph",
          bullets: [
            {
              text: "SV_S3_Bullet1",
            },
            {
              text: "SV_S3_Bullet2",
            },
          ],
          popupImage: require("@/assets/scenes/scene3/MES3Area_selection.png"),
          videoUrl: "paHMRz2bxJI",
          transcription: "/videos/scene3/intro.txt",
          audioUrl: "/audio/scene3/Un milieu inclusif et stimulant pour tous_01.mp3",
          altPopup: "SV_S3_AltPopup",
          replaceVideo: null,
          popupTitle: "SV_S3_popupTitle",
          popupParagraphs: [
            {
              text: "SV_S3_popupParagraph1",
            },
          ],
          audioPopup: "/audio/scene3/Un milieu inclusif et stimulant pour tous_02.mp3",
        },
        {
          id: "id-situation-4",
          paragraph: "SV_S4_Paragraph",
          bullets: [
            {
              text: "SV_S4_Bullet1",
            },
            {
              text: "SV_S4_Bullet2",
            },
          ],
          popupImage: require("@/assets/scenes/scene4/MES4Area_selection.png"),
          //videoUrl: "/videos/scene4/intro.mp4",
          videoUrl: "https://content.jwplatform.com/videos/Fxa4tl6D-O8RTBfsm.mp4",
          poster: "https://content.jwplatform.com/thumbs/Fxa4tl6D-1280.jpg",
          mediaId: "Fxa4tl6D",
          transcription: "/videos/scene4/intro.txt",
          audioUrl: "/audio/scene4/Ici, je suis chez moi_001.mp3",
          altPopup: "SV_S4_AltPopup",
          replaceVideo: null,
          popupTitle: "SV_S4_popupTitle",
          popupParagraphs: [
            {
              text: "SV_S4_popupParagraph1",
            },
          ],
          audioPopup: "/audio/scene4/Ici, je suis chez moi_002.mp3",
        },
        {
          id: "id-situation-5",
          paragraph: "SV_S5_Paragraph",
          bullets: [
            {
              text: "SV_S5_Bullet1",
            },
            {
              text: "SV_S5_Bullet2",
            },
          ],
          popupImage: require("@/assets/scenes/scene5/MES5Area_selection.png"),
          videoUrl: "https://content.jwplatform.com/videos/k5bglSO5-O8RTBfsm.mp4",
          //poster: "https://content.jwplatform.com/thumbs/k5bglSO5-1280.jpg",
          mediaId: "k5bglSO5",
          poster: "/videos/scene5/introPoster.jpg",
          transcription: "/videos/scene5/intro.txt",
          audioUrl: "/audio/scene5/Nature et découverte_001.mp3",
          altPopup: "SV_S5_AltPopup",
          replaceVideo: null,
          popupTitle: "SV_S5_popupTitle",
          popupParagraphs: [
            {
              text: "SV_S5_popupParagraph1",
            },
          ],
          audioPopup: "/audio/scene5/Nature et découverte_002.mp3",
        },
        {
          id: "id-situation-6",
          paragraph: "SV_S6_Paragraph",
          bullets: [
            {
              text: "SV_S6_Bullet1",
            },
          ],
          popupImage: require("@/assets/scenes/scene6/MES6Area_selection.png"),
          videoUrl: "https://content.jwplatform.com/videos/qMkqcpt3-O8RTBfsm.mp4",
          poster: "https://content.jwplatform.com/thumbs/qMkqcpt3-1280.jpg",
          mediaId: "qMkqcpt3",
          transcription: "/videos/scene6/intro.txt",
          audioUrl: "/audio/scene6/Un environnement riche_001.mp3",
          altPopup: "SV_S6_AltPopup",
          replaceVideo: null,
          popupTitle: "SV_S6_popupTitle",
          popupParagraphs: [
            {
              text: "SV_S6_popupParagraph1",
              popover: "SV_S6_popupParagraph1_popover",
            },
          ],
          audioPopup: "/audio/scene6/Un environnement riche_002.mp3",
        },
        {
          id: "id-situation-7",
          paragraph: "SV_S7_Paragraph",
          bullets: [
            {
              text: "SV_S7_Bullet1",
              popover: "SV_S7_Bullet1_popover",
            },
          ],
          popupImage: require("@/assets/scenes/scene7/MES7Area_selection.png"),
          videoUrl: "5zvNIVLUUDU",
          transcription: "/videos/scene7/intro.txt",
          audioUrl: "/audio/scene7/Cultiver des saines habitudes de vie_001.mp3",
          altPopup: "SV_S7_AltPopup",
          replaceVideo: null,
          popupTitle: "SV_S7_popupTitle",
          popupParagraphs: [
            {
              text: "SV_S7_popupParagraph1",
            },
          ],
          audioPopup: "/audio/scene7/Cultiver des saines habitudes de vie_002.mp3",
        },
        {
          id: "id-situation-8",
          paragraph: "SV_S8_Paragraph",
          bullets: [
            {
              text: "SV_S8_Bullet1",
            },
            {
              text: "SV_S8_Bullet2",
            },
          ],
          popupImage: require("@/assets/scenes/scene8/MES8Area_selection.png"),
          //videoUrl: "/videos/scene8/intro.mp4",
          videoUrl: "https://content.jwplatform.com/videos/Xcf9CAGM-O8RTBfsm.mp4",
          poster: "https://content.jwplatform.com/thumbs/Xcf9CAGM-1280.jpg",
          mediaId: "Xcf9CAGM",
          transcription: "/videos/scene8/intro.txt",
          audioUrl: "/audio/scene8/On joue dehors_001.mp3",
          altPopup: "SV_S8_AltPopup",
          replaceVideo: null,
          popupTitle: "SV_S8_popupTitle",
          popupParagraphs: [
            {
              text: "SV_S8_popupParagraph1",
            },
          ],
          audioPopup: "/audio/scene8/On joue dehors_002.mp3",
        },
        {
          id: "id-situation-9",
          paragraph: "SV_S9_Paragraph",
          bullets: [
            {
              text: "SV_S9_Bullet1",
              popover: "SV_S9_Bullet1_popover",
            },
            {
              text: "SV_S9_Bullet2",
            },
            {
              text: "SV_S9_Bullet3",
            },
          ],
          popupImage: require("@/assets/scenes/scene9/MES9Area_selection.png"),
          //videoUrl: "/videos/scene8/intro.mp4",
          videoUrl: "https://cdn.jwplayer.com/videos/2OQTyQNZ-O8RTBfsm.mp4",
          poster: "https://cdn.jwplayer.com/thumbs/2OQTyQNZ-1280.jpg",
          mediaId: "2OQTyQNZ",
          transcription: "/videos/scene9/intro.txt",
          audioUrl: "/audio/scene9/MES1-1.mp3",
          altPopup: "SV_S9_AltPopup",
          replaceVideo: null,
          popupTitle: "SV_S9_popupTitle",
          popupParagraphs: [
            {
              text: "SV_S9_popupParagraph1",
            },
          ],
          audioPopup: "/audio/scene9/MES1-2.mp3",
        },
        {
          id: "id-situation-10",
          paragraph: "SV_S10_Paragraph",
          bullets: [
            {
              text: "SV_S10_Bullet1",
            },
            {
              text: "SV_S10_Bullet2",
            },
            {
              text: "SV_S10_Bullet3",
            },
          ],
          popupImage: require("@/assets/scenes/scene10/MES10Area_selection.png"),
          //videoUrl: "/videos/scene8/intro.mp4",
          videoUrl: "https://cdn.jwplayer.com/videos/fEams25A-O8RTBfsm.mp4",
          poster: "https://cdn.jwplayer.com/thumbs/fEams25A-1280.jpg",
          mediaId: "fEams25A",
          transcription: "/videos/scene10/intro.txt",
          audioUrl: "/audio/scene10/MES2-1.mp3",
          altPopup: "SV_S10_AltPopup",
          replaceVideo: null,
          popupTitle: "SV_S10_popupTitle",
          popupParagraphs: [
            {
              text: "SV_S10_popupParagraph1",
            },
          ],
          audioPopup: "/audio/scene10/MES2-2.mp3",
        },
        {
          id: "id-situation-11",
          paragraph: "SV_S11_Paragraph",
          bullets: [
            {
              text: "SV_S11_Bullet1",
            },
            {
              text: "SV_S11_Bullet2",
            },
            {
              text: "SV_S11_Bullet3",
            },
          ],
          popupImage: require("@/assets/scenes/scene11/MES11Area_selection.png"),
          //videoUrl: "/videos/scene8/intro.mp4",
          trackUrl: "/videos/pret-pour-la-vie_caption.vtt",
          videoUrl: "https://cdn.jwplayer.com/videos/nxewvHE0-O8RTBfsm.mp4",
          poster: "https://cdn.jwplayer.com/thumbs/nxewvHE0-1280.jpg",
          mediaId: "nxewvHE0",
          transcription: "/videos/scene11/intro.txt",
          audioUrl: "/audio/scene11/MES3-1.mp3",
          altPopup: "SV_S11_AltPopup",
          replaceVideo: null,
          popupTitle: "SV_S11_popupTitle",
          popupParagraphs: [
            {
              text: "SV_S11_popupParagraph1",
            },
            {
              text: "SV_S11_popupParagraph2",
            },
          ],
          audioPopup: "/audio/scene11/MES3-2.mp3",
        },
        {
          id: "id-situation-12",
          paragraph: "SV_S12_Paragraph",
          bullets: [
            {
              text: "SV_S12_Bullet1",
              popover: "SV_S12_Bullet1_popover1",
              popover2: "SV_S12_Bullet1_popover2",
            },
            {
              text: "SV_S12_Bullet2",
            },
            {
              text: "SV_S12_Bullet3",
            },
          ],
          popupImage: require("@/assets/scenes/scene12/MES12Area_selection.png"),
          //videoUrl: "/videos/scene8/intro.mp4",
          videoUrl: "https://cdn.jwplayer.com/videos/68IkEgKt-O8RTBfsm.mp4",
          poster: "https://cdn.jwplayer.com/thumbs/68IkEgKt-1280.jpg",
          mediaId: "68IkEgKt",
          transcription: "/videos/scene12/intro.txt",
          audioUrl: "/audio/scene12/MES4-1.mp3",
          altPopup: "SV_S12_AltPopup",
          replaceVideo: null,
          popupTitle: "SV_S12_popupTitle",
          popupParagraphs: [
            {
              text: "SV_S12_popupParagraph1",
            },
            {
              text: "SV_S12_popupParagraph2",
              popover: "SV_S12_popupParagraph2Popover1",
            },
          ],
          audioPopup: "/audio/scene12/MES4-2.mp3",
        },
      ],

      // Variables
      videoLoading: false,
      continueAudio: "/audio/partager/partager_clique_commencer.mp3",
      watchVideo: "/audio/partager/partager_visionne_video.mp3",

      // Images
      spinnerUrl: "data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==",
    };
  },
  computed: {},
  created() {
    this.setArea(this.areaName);
    this.setSituation(this.situationName);

    this.situationIndex = this.getSituationIndexFromSituationName(this.situationName);
  },
  methods: {
    hasIntroAudio() {
      if (this.getIntroAudio() == null) {
        return false;
      }
      return true;
    },
    getIntroAudio() {
      return this.situations[this.getCurrentSituation()].audioUrl;
    },
    hasPopupAudio() {
      if (this.situations[this.getCurrentSituation()].audioPopup != null) {
        return true;
      }
      return false;
    },
    getPopupAudio() {
      return this.situations[this.getCurrentSituation()].audioPopup;
    },
    isStartButtonDisabled() {
      // Some situations (ie: #2) don't have a video, so don't disable start button
      if (!this.hasVideo()) {
        return false;
      }
      // Disable the start button until the user has watched the video
      if (this.$store.state.gamestate.watchedSituationVideo[this.getCurrentSituation()] == true) {
        return false;
      }

      return true;
    },
    onMuteClicked() {
      if (this.$refs.videoPlayerRef != null) {
        // Mute the youtube video when mute button clicked (other type of video is automatic)
        if (this.$store.state.gamestate.muted) {
          this.$refs.videoPlayerRef.setMute(true);
        } else {
          this.$refs.videoPlayerRef.setMute(false);

          // When unmututing the audio, if the video is playing, pause the startup audio
          if (this.$refs.videoPlayerRef.isPlaying) {
            this.pauseAllAudio();
          }
        }
      }
    },
    onVideoStarted() {
      // Pause all audio when video starts -
      this.pauseAllAudio();
    },
    onVideoEnded() {
      var currentSituation = this.getCurrentSituation();
      this.$store.commit("setWatchedSituationVideo", currentSituation);
      this.saveGameState();
      this.$refs.continueAudioRef.playAudio();
    },
    onVideoReady() {
      this.videoLoading = false;
    },
    onIntroAudioEnded() {
      if (this.isStartButtonDisabled()) {
        this.$refs.watchVideoAudioRef.playAudio();
      }
    },
    hasBulletPopover(index) {
      if (this.getBullets()[index].popover != null) {
        return true;
      }
      return false;
    },
    getBulletPopover(index) {
      return this.getBullets()[index].popover;
    },
    getBulletPopover2(index) {
      return this.getBullets()[index].popover2;
    },
    getParagraph() {
      return this.situations[this.getCurrentSituation()].paragraph;
    },
    getBullets() {
      return this.situations[this.getCurrentSituation()].bullets;
    },
    getBulletText(index) {
      return this.getBullets()[index].text;
    },
    getPopupTitle() {
      return this.situations[this.getCurrentSituation()].popupTitle;
    },
    getPopupImage() {
      return this.situations[this.getCurrentSituation()].popupImage;
    },
    getPopupAlt() {
      return this.situations[this.getCurrentSituation()].altPopup;
    },
    hasVideo() {
      if (this.getReplaceVideo() == null) {
        return true;
      }
      return false;
    },
    getReplaceVideo() {
      return this.situations[this.getCurrentSituation()].replaceVideo;
    },
    getVideoUrl() {
      return this.situations[this.getCurrentSituation()].videoUrl;
    },
    getMediaId() {
      return this.situations[this.getCurrentSituation()].mediaId;
    },
    getTrackUrl() {
      return this.situations[this.getCurrentSituation()].trackUrl;
    },
    getVideoPoster() {
      if (this.situations[this.getCurrentSituation()].poster == null) {
        return "";
      }
      return this.situations[this.getCurrentSituation()].poster;
    },
    getVideoTranscription() {
      return this.situations[this.getCurrentSituation()].transcription;
    },
    isVideoYoutube() {
      if (!this.hasVideo()) {
        return "no";
      }
      var url = this.getVideoUrl();
      //console.log(url);
      if (url.includes(".mp4")) {
        return "no";
      }
      return "yes";
    },
    getPopupParagraphs() {
      return this.situations[this.getCurrentSituation()].popupParagraphs;
    },
    hasPopupPopover(index) {
      if (this.getPopupParagraphs()[index].popover != null) {
        return true;
      }
      return false;
    },
    getPopupParagragraphPopover2(popupParagraph) {
      // A special case where there are 2 popovers in a single paragraph
      // this seems hacky, but it only occurs once in the whole appp so...
      if (popupParagraph.popover2 != null) {
        return this.LG(popupParagraph.popover2);
      } else {
        return null;
      }
    },
    getCurrentSituation() {
      return this.$store.state.gamestate.situation;
    },
    onStartButtonClicked() {
      if (this.$refs.videoPlayerRef != null) {
        this.$refs.videoPlayerRef.StopVideo();
      }

      // this.$nextTick(this.giveFocusToPopup());

      if (this.$refs.introAudioRef != null) {
        this.$refs.introAudioRef.pauseAudio();
      }
      if (this.$refs.continueAudioRef != null) {
        this.$refs.continueAudioRef.pauseAudio();
      }
      if (this.$refs.popupAudioRef != null) {
        this.$refs.popupAudioRef.playAudio();
      }
      console.log(this.$refs.popupAudioRef);
      this.$bvModal.show("modal-intro");
    },
    giveFocusToPopup() {
      if (this.$refs.popupRef != null) {
        this.$refs.popupRef.focusPopup();
      }
      this.popToTopOfPage();
    },
    onPopupStartButtonClicked() {
      if (this.newVersion()) {
        this.$router.push(`/${this.areaName}/${this.situationName}/tutoriel`);
      } else {
        this.$router.push("/jouer");
      }
    },
    onPopupCloseButtonClicked() {
      this.$refs.popupAudioRef.pauseAudio();
    },
  },
};
</script>

<style scoped>
.h2 {
  font-size: 18px !important;
  font-weight: bold;
}

.bloc-note-link-wrapper {
  position: relative;

  border-radius: 20px;
  border: 10px solid #ffffff;
  padding: 10px !important;
  background-color: #f3f3f3;

  margin-top: 30px;
  padding: 20px !important;
  padding-right: 30px !important;
}
.recaps-bloc-note-btn {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(55%, -50%);
}
.video-bloc-note-btn {
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import url("https://fonts.googleapis.com/css?family=Poppins");

.popover-box {
  background-color: black;
  color: white;
}

.bg-select-video-area {
  background-color: #eaeaea;
  color: black;
  max-width: 1000px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  margin-top: 30px;
  margin-bottom: 30px;
  font-family: "Poppins";
  font-size: 17px;
  padding: 10px;
}

.selection-vid-area {
  margin-top: 30px;
  margin-bottom: 30px;
  margin-right: 30px;
  background-color: #eaeaea;
  font-family: "Poppins";
  font-size: 17px;
  padding: 10px;
}

.selection-vid-container {
  width: 95%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.selection-vid-area-new {
  border-radius: 57px;
  border: 10px solid #ffffff;
  background-color: #eaeaea;
  font-family: "Poppins";
  font-size: 17px;
  color: black;
  padding-left: 450px;
  padding-right: 20px;
  min-height: 640px;
}

.video-element {
  padding: 10px;
}
.video-left-side {
  position: absolute;
  top: 10%;
  left: 0px;
  width: 95%;
  max-width: 500px;
}
.video-text-bubble-new {
  background-color: #e8eff2;
  color: black;
  font-family: "Nunito";
  font-size: 17px;
  border-radius: 40px;
  border: 10px solid #ffffff;
  padding: 25px;
  z-index: 1;
}

.video-text-bubble-new a:link {
  color: #0563c1 !important;
  text-decoration: none !important;
}

.video-text-bubble-new a:visited {
  color: #0563c1 !important;
  text-decoration: none !important;
}

.video-text-bubble-new a:hover {
  color: #004a7f !important;
}

.video-text-bubble-new a:active {
  color: #155168 !important;
}

.bg-color-vid-green {
  background-color: #3f5d12;
  border: 1px solid #8cbbe9;
  padding: 14px;
  color: white;
  min-height: 540px;
  margin-left: 20px;
  margin-top: 30px;
  margin-bottom: 30px;
  margin-right: 0px;
  font-family: "Nunito";
  font-size: 17px;
}

.bg-color-vid-green a:link {
  color: white !important;
  text-decoration: underline !important;
}

.bg-color-vid-green a:visited {
  color: white !important;
  text-decoration: underline !important;
}

.bg-color-vid-green a:hover {
  color: aquamarine !important;
}

.bg-color-vid-green a:active {
  color: aquamarine !important;
}

.replace-vid-area {
  padding: 10px !important;
}

@media only screen and (max-width: 600px) {
  .bg-color-vid-green {
    margin-right: 20px !important;
    margin-left: 20px !important;
  }

  .selection-vid-area {
    margin-top: 10px;
    margin-right: 25px;
    margin-left: 25px;
    background-color: #eaeaea;
  }
}

@media only screen and (max-width: 1300px) {
  .message-behind-video-new {
    max-width: 90% !important;
  }

  .video-left-side {
    position: relative;
    top: 30px;
    left: 0px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 1000px;
    font-size: 22px !important;
  }

  .message-behind-video {
    max-width: 100%;
  }

  .selection-vid-container {
    padding-top: 50px;
  }

  .selection-vid-area-new {
    padding: 0px;
  }
}
</style>
